import { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";

export function FAQ() {
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const faqs = [
        { q: "Quanto tempo para ver resultados?", a: "A maioria dos nossos clientes começa a ver resultados em 7 a 15 dias. Em 30 dias sua agenda já estará significativamente mais cheia." },
        { q: "Preciso ter experiência com marketing?", a: "Não! Cuidamos de tudo para você. Desde a criação das campanhas até o atendimento com IA." },
        { q: "Funciona para qualquer especialidade?", a: "Sim! Já atendemos clínicas de estética, ortopedia, dermatologia, odontologia, fisioterapia e muitas outras." },
        { q: "Qual o investimento necessário?", a: "Trabalhamos com diferentes planos. Agende uma conversa para apresentarmos a melhor opção para sua clínica." },
        { q: "E se eu não gostar do serviço?", a: "Você pode cancelar a qualquer momento. Não trabalhamos com fidelidade." },
    ];

    return (
        <section className="py-20 bg-white">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <span className="inline-flex items-center gap-2 text-brand-600 font-semibold mb-4">
                        <HelpCircle className="w-5 h-5" />DÚVIDAS FREQUENTES
                    </span>
                    <h2 className="text-3xl sm:text-4xl font-bold text-slate-900">Perguntas e respostas</h2>
                </div>
                <div className="space-y-4">
                    {faqs.map((faq, i) => (
                        <div key={i} className="border border-slate-200 rounded-xl overflow-hidden">
                            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left hover:bg-slate-50">
                                <span className="font-semibold text-slate-900">{faq.q}</span>
                                <ChevronDown className={`w-5 h-5 text-slate-500 transition-transform ${openIndex === i ? "rotate-180" : ""}`} />
                            </button>
                            {openIndex === i && <div className="px-5 pb-5 text-slate-600">{faq.a}</div>}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
